// client_serena/src/api/fetchUserData.js
// ✅ Fix: Accept token as a parameter

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const fetchUserData = async (token) => {
  const res = await fetch(`${API_BASE_URL}/api/user/me`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.msg || "Failed to fetch user");
  }

  const data = await res.json();
  return data;
};
